import '../styles/Footer.css';
import logo from '../assets/images/Q3LOGO_notext.png';
import iyqlogo from '../assets/images/IYQ.png';


function Footer() {
    return (
        
        <div className='Footer'>
            <div className='footer-desktop-row'>
                <img src={logo} className="footer-logo" alt="Q^3 Logo" />
                <img src={iyqlogo} className="footer-iyq-logo" alt="IYQ Logo" />
                <div className= 'footer-links'>
                    <a href='/' style={{ textDecoration: 'none'}}>Home</a>
                    <a href="/registration" style={{ textDecoration: 'none'}}>Registration</a>
                    <a href="/faq" style={{ textDecoration: 'none'}}>FAQ</a>
                    <a href="mailto:hello@q3initiative.org" style={{ textDecoration: 'none'}}>Contact Us</a>
                </div>
            </div>
        </div>
  );
}

export default Footer;